import React from 'react';
import { Palabra, ContenedorPresentacion, Texto, ContenedorImg } from '../styles';

const Presentacion = () => {
    return ( 
        <ContenedorPresentacion>
            <Texto>
                <h1>Hi, my name is</h1>
                <h2>Ezequiel Luján.</h2>
                <h3>I'm {Palabra}</h3>
            </Texto>
            <ContenedorImg>
                <img src="./feeling_proud.svg" alt="Feeling Proud" />
            </ContenedorImg>
        </ContenedorPresentacion>
    );
}
 
export default Presentacion;